import SideNav from "./sidenav";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import PaymentBg from "../images/payments.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Download from "../images/downloadicon.png";
import Check from "../images/check.png";
import ExcelExportButton from './excelExport';
import CSVExportButton from './csvExport';
import PDFExportButton from './pdfExport';
import "./history.css";
import moment from 'moment';
import { $ } from "jquery";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { faker } from '@faker-js/faker';



function createRandomNumerals(){ 

    return faker.number.float({ min: 20, max: 30 }) // 23.94764115102589
    
}

const dataInfo = faker.helpers.multiple(createRandomNumerals, {
  count: 5,
});



const History = () => {

        const [active, setActive] = useState("RSA FUND I");
        const[ fundOneData, setFundOneData] = useState([])
        const[ fundTwoData, setFundTwoData] = useState([])
        const[ fundThreeData, setFundThreeData] = useState([])
        const[ fundFourData, setFundFourData] = useState([])
        const[ fundFiveData, setFundFiveData] = useState([])
        const[ fundSixData, setFundSixData] = useState([])
        const[ fundSixRFData, setFundSixRFData] = useState([])
        const[ duration, setDuration] = useState(7)
        const[ fundOneDataLabels, setFundOneDataLabels] = useState([])
        const[ fundOneDataValues, setFundOneDataValues] = useState([])

   window.scrollTo(0, 0)

   
   
  const params = useParams()

  

  useEffect(  () => {
   
  assetAllocation()
  fundTrendPrices()

        
        }, []) 


  ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

 const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: false,
      text: 'Chart.js Line Chart',
    },
   
    
  },
};

const labels = fundOneDataLabels;

console.log(labels)

 const data = {
  labels,
  datasets: [
    {
      label: 'Dataset 1',
      data: fundOneDataValues,
      borderColor: 'rgba(255, 123, 32, 1)',
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
    },
   
  ],
};




  //assest allocation 

const baseUrl = 'https://mapps.leadway-pensure.com/PensureWebsiteAPI/WebData/AssetAllocation';
const url = new URL(baseUrl);

// Add query params to the URL
url.searchParams.append('clientId', '9dy8earw04r09wjefsdp90zsjs');



async function assetAllocation(){


    const priceUpdate = await fetch(url, { 
    method:"POST",
    headers:{
      "content-type":"application/JSON"
    }
  })

   .then(response => response.json())
   .then(response => {
     console.log(response)

     setFundOneData(response.Data.Fund1)
     setFundTwoData(response.Data.Fund2)
     setFundThreeData(response.Data.Fund3)
     setFundFourData(response.Data.Fund4)
     setFundFiveData(response.Data.Fund5)
     setFundSixData(response.Data.Fund6)
     setFundSixRFData(response.Data.Fund6RF)

  })
    }


const baseTrendUrl = 'https://mapps.leadway-pensure.com/LeadwayMobileApplicationWebAPI/WebData/Chart';
const trendUrl = new URL(baseTrendUrl);

// Add query params to the URL
trendUrl.searchParams.append('clientId', '9dy8earw04r09wjefsdp90zsjs');

let fundDetails1
let fundDetails2
let fundDetails3
let fundDetails4
let fundDetails5
let fundDetails6
let fundDetails6RF


 fundDetails1 = {
  Fund1: true,
  duration: duration
};

 fundDetails2 = {
  Fund2: true,
  duration: duration
};

 fundDetails3 = {
  Fund3: true,
  duration: duration
}

 fundDetails4 = {
  Fund4: true,
  duration: duration
}


 fundDetails5 = {
  Fund5: true,
  duration: duration
}

 fundDetails6 = {
  Fund6: true,
  duration: duration
}

 fundDetails6RF = {
  Fund6RF: true,
  duration: duration
}


function trigger() { 

   $('.fund-btn' ).on('click', function() { 
//alert($(this).attr('id'))
   setFundOneDataValues( fundOneDataValues => [])
   setFundOneDataLabels( fundOneDataLabels => [])
if( $(this).attr('id') === "RSA FUND I"){ 
fundTrendPrices()
}
if( $(this).attr('id') === "RSA FUND II"){ 
fundTwoTrendPrices()
}

if( $(this).attr('id') === "RSA FUND III"){ 
fundThreeTrendPrices()
}

if( $(this).attr('id') === "RSA FUND IV"){ 
fundFourTrendPrices()
}

if( $(this).attr('id') === "RSA FUND V"){ 
fundFiveTrendPrices()
}

if( $(this).attr('id') === "RSA FUND VI (Active)"){ 
fundSixTrendPrices()
}

if( $(this).attr('id') === "RSA FUND VI (Retiree)"){ 
fundSixRFTrendPrices()
}

  
  })

}

//download file RSA I 


async function fundTrendPrices(){

setDuration(duration => 7 )
   console.log('call')
   console.log(fundDetails1)
    const priceUpdate = await fetch(trendUrl, { 
    method:"POST",
    headers:{
      "content-type":"application/JSON"
    },
      body: JSON.stringify(fundDetails1)
  })

   .then(response => response.json())
   .then(response => {
     console.log(response.Data.values)

   
     setFundOneDataLabels( fundOneDataLabels => response.Data.Datelabels)
     setFundOneDataValues ( fundOneDataValues => response.Data.values)

  })

    }

 async function fundOneTrendPricesNew(SD){

   fundDetails1 = {
  Fund1: true,
  duration: SD
};

   console.log('call')
   console.log(fundDetails1)
    const priceUpdate = await fetch(trendUrl, { 
    method:"POST",
    headers:{
      "content-type":"application/JSON"
    },
      body: JSON.stringify(fundDetails1)
  })

   .then(response => response.json())
   .then(response => {
     // console.log(response.Data.values)

   
     setFundOneDataLabels( fundOneDataLabels => response.Data.Datelabels)
     setFundOneDataValues ( fundOneDataValues => response.Data.values)

  })

    }

  $('.getTrendData14, .getTrendData7, .getTrendData2 , .getTrendData3 ' ).on('click', function() { 
 // alert($(this).attr('id'))
   setFundOneDataValues( fundOneDataValues => [])
   setFundOneDataLabels( fundOneDataLabels => [])
  let sanitizedDuration = parseInt($(this).attr('id'))
  //alert(typeof sanitizedDuration)
  //alert(sanitizedDuration)
  fundOneTrendPricesNew(sanitizedDuration) 
  })

  async function fundTwoTrendPrices(){
      setDuration(duration => 7 )
   //console.log('call')
   //console.log(fundDetails2)
    const priceUpdate = await fetch(trendUrl, { 
    method:"POST",
    headers:{
      "content-type":"application/JSON"
    },
      body: JSON.stringify(fundDetails2)
  })

   .then(response => response.json())
   .then(response => {
    // console.log(response.Data.values)

   
     setFundOneDataLabels( fundOneDataLabels => response.Data.Datelabels)
     setFundOneDataValues ( fundOneDataValues => response.Data.values)

  })

    }

     async function fundTwoTrendPricesNew(SD){

   fundDetails2 = {
  Fund2: true,
  duration: SD
};

    const priceUpdate = await fetch(trendUrl, { 
    method:"POST",
    headers:{
      "content-type":"application/JSON"
    },
      body: JSON.stringify(fundDetails2)
  })

   .then(response => response.json())
   .then(response => {
     // console.log(response.Data.values)

   
     setFundOneDataLabels( fundOneDataLabels => response.Data.Datelabels)
     setFundOneDataValues ( fundOneDataValues => response.Data.values)

  })

    }


    $('.getTrendData14a, .getTrendData7a, .getTrendData2a , .getTrendData3a ' ).on('click', function() { 
 // alert($(this).attr('id'))
   setFundOneDataValues( fundOneDataValues => [])
   setFundOneDataLabels( fundOneDataLabels => [])
  let sanitizedDuration = parseInt($(this).attr('id'))
  //alert(typeof sanitizedDuration)
  //alert(sanitizedDuration)
  fundTwoTrendPricesNew(sanitizedDuration) 
  })




  async function fundThreeTrendPrices(){
      setDuration(duration => 7 )
   //console.log('call')
   //console.log(fundDetails2)
    const priceUpdate = await fetch(trendUrl, { 
    method:"POST",
    headers:{
      "content-type":"application/JSON"
    },
      body: JSON.stringify(fundDetails3)
  })

   .then(response => response.json())
   .then(response => {
    // console.log(response.Data.values)

   
     setFundOneDataLabels( fundOneDataLabels => response.Data.Datelabels)
     setFundOneDataValues ( fundOneDataValues => response.Data.values)

  })

    }

 async function fundThreeTrendPricesNew(SD){

   fundDetails3 = {
  Fund3: true,
  duration: SD
};

    const priceUpdate = await fetch(trendUrl, { 
    method:"POST",
    headers:{
      "content-type":"application/JSON"
    },
      body: JSON.stringify(fundDetails3)
  })

   .then(response => response.json())
   .then(response => {
     // console.log(response.Data.values)

   
     setFundOneDataLabels( fundOneDataLabels => response.Data.Datelabels)
     setFundOneDataValues ( fundOneDataValues => response.Data.values)

  })

    }


   $('.getTrendData14b, .getTrendData7b, .getTrendData2b , .getTrendData3b ' ).on('click', function() { 
 // alert($(this).attr('id'))
   setFundOneDataValues( fundOneDataValues => [])
   setFundOneDataLabels( fundOneDataLabels => [])
  let sanitizedDuration = parseInt($(this).attr('id'))
  //alert(typeof sanitizedDuration)
  //alert(sanitizedDuration)
  fundThreeTrendPricesNew(sanitizedDuration) 
  })



  async function fundFourTrendPrices(){
      setDuration(duration => 7 )
   //console.log('call')
   //console.log(fundDetails2)
    const priceUpdate = await fetch(trendUrl, { 
    method:"POST",
    headers:{
      "content-type":"application/JSON"
    },
      body: JSON.stringify(fundDetails4)
  })

   .then(response => response.json())
   .then(response => {
    // console.log(response.Data.values)

   
     setFundOneDataLabels( fundOneDataLabels => response.Data.Datelabels)
     setFundOneDataValues ( fundOneDataValues => response.Data.values)

  })

    }

 async function fundFourTrendPricesNew(SD){

  fundDetails4 = {
  Fund4: true,
  duration: SD
};

    const priceUpdate = await fetch(trendUrl, { 
    method:"POST",
    headers:{
      "content-type":"application/JSON"
    },
      body: JSON.stringify(fundDetails4)
  })

   .then(response => response.json())
   .then(response => {
     // console.log(response.Data.values)

  
     setFundOneDataLabels( fundOneDataLabels => response.Data.Datelabels)
     setFundOneDataValues ( fundOneDataValues => response.Data.values)

  })

    }


   $('.getTrendData14c, .getTrendData7c, .getTrendData2c , .getTrendData3c ' ).on('click', function() { 
 // alert($(this).attr('id'))
   setFundOneDataValues( fundOneDataValues => [])
   setFundOneDataLabels( fundOneDataLabels => [])
  let sanitizedDuration = parseInt($(this).attr('id'))
  //alert(typeof sanitizedDuration)
  //alert(sanitizedDuration)
  fundFourTrendPricesNew(sanitizedDuration) 
  })


    async function fundFiveTrendPrices(){
      setDuration(duration => 7 )
   //console.log('call')
   //console.log(fundDetails2)
    const priceUpdate = await fetch(trendUrl, { 
    method:"POST",
    headers:{
      "content-type":"application/JSON"
    },
      body: JSON.stringify(fundDetails5)
  })

   .then(response => response.json())
   .then(response => {
    // console.log(response.Data.values)

   
     setFundOneDataLabels( fundOneDataLabels => response.Data.Datelabels)
     setFundOneDataValues ( fundOneDataValues => response.Data.values)

  })

    }

 async function fundFiveTrendPricesNew(SD){

  fundDetails5 = {
  Fund5: true,
  duration: SD
};

    const priceUpdate = await fetch(trendUrl, { 
    method:"POST",
    headers:{
      "content-type":"application/JSON"
    },
      body: JSON.stringify(fundDetails5)
  })

   .then(response => response.json())
   .then(response => {
     // console.log(response.Data.values)

  
     setFundOneDataLabels( fundOneDataLabels => response.Data.Datelabels)
     setFundOneDataValues ( fundOneDataValues => response.Data.values)

  })

    }


   $('.getTrendData14d, .getTrendData7d, .getTrendData2d , .getTrendData3d ' ).on('click', function() { 
 // alert($(this).attr('id'))
   setFundOneDataValues( fundOneDataValues => [])
   setFundOneDataLabels( fundOneDataLabels => [])
  let sanitizedDuration = parseInt($(this).attr('id'))
  //alert(typeof sanitizedDuration)
  //alert(sanitizedDuration)
  fundFiveTrendPricesNew(sanitizedDuration) 
  })


    async function fundSixTrendPrices(){
      setDuration(duration => 7 )
   //console.log('call')
   //console.log(fundDetails2)
    const priceUpdate = await fetch(trendUrl, { 
    method:"POST",
    headers:{
      "content-type":"application/JSON"
    },
      body: JSON.stringify(fundDetails6)
  })

   .then(response => response.json())
   .then(response => {
    // console.log(response.Data.values)

   
     setFundOneDataLabels( fundOneDataLabels => response.Data.Datelabels)
     setFundOneDataValues ( fundOneDataValues => response.Data.values)

  })

    }

 async function fundSixTrendPricesNew(SD){

  fundDetails6 = {
  Fund6: true,
  duration: SD
};

    const priceUpdate = await fetch(trendUrl, { 
    method:"POST",
    headers:{
      "content-type":"application/JSON"
    },
      body: JSON.stringify(fundDetails6)
  })

   .then(response => response.json())
   .then(response => {
     // console.log(response.Data.values)

  
     setFundOneDataLabels( fundOneDataLabels => response.Data.Datelabels)
     setFundOneDataValues ( fundOneDataValues => response.Data.values)

  })

    }


   $('.getTrendData14e, .getTrendData7e, .getTrendData2e , .getTrendData3e ' ).on('click', function() { 
 // alert($(this).attr('id'))
   setFundOneDataValues( fundOneDataValues => [])
   setFundOneDataLabels( fundOneDataLabels => [])
  let sanitizedDuration = parseInt($(this).attr('id'))
  //alert(typeof sanitizedDuration)
  //alert(sanitizedDuration)
  fundSixTrendPricesNew(sanitizedDuration) 
  })


 async function fundSixRFTrendPrices(){
      setDuration(duration => 7 )
   //console.log('call')
   //console.log(fundDetails2)
    const priceUpdate = await fetch(trendUrl, { 
    method:"POST",
    headers:{
      "content-type":"application/JSON"
    },
      body: JSON.stringify(fundDetails6RF)
  })

   .then(response => response.json())
   .then(response => {
    // console.log(response.Data.values)

   
     setFundOneDataLabels( fundOneDataLabels => response.Data.Datelabels)
     setFundOneDataValues ( fundOneDataValues => response.Data.values)

  })

    }

 async function fundSixRFTrendPricesNew(SD){

  fundDetails6RF = {
  Fund6RF: true,
  duration: SD
};

    const priceUpdate = await fetch(trendUrl, { 
    method:"POST",
    headers:{
      "content-type":"application/JSON"
    },
      body: JSON.stringify(fundDetails6RF)
  })

   .then(response => response.json())
   .then(response => {
     // console.log(response.Data.values)

  
     setFundOneDataLabels( fundOneDataLabels => response.Data.Datelabels)
     setFundOneDataValues ( fundOneDataValues => response.Data.values)

  })

    }


   $('.getTrendData14f, .getTrendData7f, .getTrendData2f , .getTrendData3f ' ).on('click', function() { 
 // alert($(this).attr('id'))
   setFundOneDataValues( fundOneDataValues => [])
   setFundOneDataLabels( fundOneDataLabels => [])
  let sanitizedDuration = parseInt($(this).attr('id'))
  //alert(typeof sanitizedDuration)
  //alert(sanitizedDuration)
  fundSixRFTrendPricesNew(sanitizedDuration) 
  })






  function switchFund(e){ 
    let value= e.target.value
   // alert(value)
    setActive(value)
  }


  const menuItems = [
    "RSA FUND I",
    "RSA FUND II",
    "RSA FUND III",
    "RSA FUND IV",
    "RSA FUND V",
    "RSA FUND VI (Active)",
    "RSA FUND VI (Retiree)",
  ];


  return (
    <>
   

      <div
        id="faq-types-section"
        class="containeer d-flex align-items-start   mt-4"
        style={{ backgroundColor: "none" }}
      >
        <SideNav  items={menuItems} activeItem={active} onSelect={setActive} types={false} funds={true} fundsUpdateTrigger={trigger} />

  

        <div className="flex-1 p-6 full-width">
            <h6 className="dark-history pt-3 pb-3 d-block d-md-none">Filter</h6>
                  <select className="form-select fund-select d-block d-md-none" aria-label="Default select example" onChange={switchFund}>
       <option value="RSA FUND I" selected> RSA FUND I</option>
        <option value="RSA FUND II"> RSA FUND II </option>
        <option value="RSA FUND III"> RSA FUND III </option>
          <option value="RSA FUND IV"> RSA FUND IV </option>
          <option value="RSA FUND V"> RSA FUND V </option>
          <option value="RSA FUND VI(Active)"> RSA FUND VI(Active) </option>
          <option value="RSA FUND VI(Retiree)"> RSA FUND VI(Retiree) </option>
              </select>
               {active === "RSA FUND I" && (

              <div>  
            <div className="faq-type-content">
                     <h2 className="history-h2">RSA Fund I Price History</h2>
              <p id="crd-p" className="grey-p">
                {" "}
                Price Trend For RSA Fund I
              </p>
                <hr className="btm-bdr-rma" />

                </div>

                 <div className="faq-type-content white-cont">
                    <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
  <li className="nav-item funds-btn-gap pb-3" role="presentation">
    <button className="nav-link funds-btn active dark-p-history getTrendData7" id="7"  data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true"> Last 7 Days </button>
  </li>
  <li className="nav-item funds-btn-gap" role="presentation">
    <button className="nav-link funds-btn dark-p-history getTrendData2" id="2"  data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Last 14 Days </button>
  </li>
  <li className="nav-item funds-btn-gap" role="presentation">
    <button className="nav-link funds-btn dark-p-history getTrendData3" id="3"  data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Last 1 Month</button>
  </li>
  <li className="nav-item" role="presentation">
    <button className="nav-link funds-btn dark-p-history getTrendData14" id="14"  data-bs-toggle="pill" data-bs-target="#pills-days" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Last 3 Months</button>
  </li>
 
</ul>
<div class="tab-content" id="pills-tabContent">
  <div class="tab-pane fade show active " id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
  <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
  <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
  <div class="tab-pane fade" id="pills-days" role="tabpanel" aria-labelledby="pills-disabled-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
</div>
            </div>


    <div className="faq-type-content">
                     <h4 className="history-h4">RSA Fund I Asset Allocation</h4>
              <p id="crd-p" className="grey-p">
                {" "}
                Asset Allocation for RSA Fund I
              </p>
                </div>

                                 <div className="mt-4 white-cont">
 <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
  <li className="nav-item funds-btn-gap" role="presentation">
    <ExcelExportButton data={fundOneData} fileName="FUND I ASSEST ALLOCATION" />
     </li>
  <li className="nav-item funds-btn-gap" role="presentation">
        <CSVExportButton data={fundOneData} fileName="FUND I ASSEST ALLOCATION" />
     </li>
  <li className="nav-item funds-btn-gap" role="presentation">
   <PDFExportButton data={fundOneData} fileName="FUND I ASSEST ALLOCATION" />
     </li>
</ul>




           
 
         <div className="mt-3 table-overflow">

            <table>
  <tr>
    <th className="head-pad">Date</th>
    <th className="head-pad">Bond%</th>
    <th className="head-pad">Equity%</th>
    <th className="head-pad">Money Market%</th>
    <th className="head-pad">Others%</th>
  </tr>

 { fundOneData.map((assetData, i) => 
             
  <tr>
    <td className="date-style"> {moment(assetData.date).format("MMM Do YYYY")} </td>
    <td className="percent-style"> {assetData.bond} </td>
    <td className="percent-style"> {assetData.equity}</td>
     <td className="percent-style">{assetData.moneyMarket}</td>
    <td className="percent-style">{assetData.cash}</td>
  </tr>
)}
</table>

         </div> 
 

                </div>


</div>
            
               )}
               {active === "RSA FUND II" && (
                
              <div>  
            <div className="faq-type-content">
                     <h2 className="history-h2">RSA Fund II Price History</h2>
              <p id="crd-p" className="grey-p">
                {" "}
                Price Trend For RSA Fund II
              </p>
                <hr className="btm-bdr-rma" />

                </div>

                 <div className="faq-type-content white-cont">
                    <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
  <li className="nav-item funds-btn-gap" role="presentation">
    <button className="nav-link funds-btn active dark-p-history getTrendData7a" id="7"  data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true"> Last 7 Days </button>
  </li>
  <li className="nav-item funds-btn-gap" role="presentation">
    <button className="nav-link funds-btn dark-p-history getTrendData2a" id="2"  data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Last 14 Days </button>
  </li>
  <li className="nav-item funds-btn-gap" role="presentation">
    <button className="nav-link funds-btn dark-p-history getTrendData3a" id="3"  data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Last 1 Month</button>
  </li>
  <li className="nav-item" role="presentation">
    <button className="nav-link funds-btn dark-p-history getTrendData14a" id="14" data-bs-toggle="pill" data-bs-target="#pills-days" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Last 3 Months</button>
  </li>
 
</ul>
<div class="tab-content" id="pills-tabContent">
  <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
  <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
  <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
  <div class="tab-pane fade" id="pills-days" role="tabpanel" aria-labelledby="pills-disabled-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
</div>
            </div>


    <div className="faq-type-content">
                     <h4 className="history-h4">RSA Fund II Asset Allocation</h4>
              <p id="crd-p" className="grey-p">
                {" "}
                Asset Allocation for RSA Fund II
              </p>
                </div>

                                 <div className="mt-4 white-cont">
 <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
  <li className="nav-item funds-btn-gap" role="presentation">
    <ExcelExportButton data={fundTwoData} fileName="FUND I ASSEST ALLOCATION" />
     </li>
  <li className="nav-item funds-btn-gap" role="presentation">
        <CSVExportButton data={fundTwoData} fileName="FUND I ASSEST ALLOCATION" />
     </li>
  <li className="nav-item funds-btn-gap" role="presentation">
   <PDFExportButton data={fundTwoData} fileName="FUND I ASSEST ALLOCATION" />
     </li>
</ul>





           
 
         <div className="mt-3 table-overflow">

            <table>
  <tr>
    <th className="head-pad">Date</th>
    <th className="head-pad">Bond%</th>
    <th className="head-pad">Equity%</th>
    <th className="head-pad">Money Market%</th>
    <th className="head-pad">Others%</th>
  </tr>
  { fundTwoData.map((assetData, i) => 
             
  <tr>
    <td className="date-style"> {moment(assetData.date).format("MMM Do YYYY")} </td>
    <td className="percent-style"> {assetData.bond} </td>
    <td className="percent-style"> {assetData.equity}</td>
     <td className="percent-style">{assetData.moneyMarket}</td>
    <td className="percent-style">{assetData.cash}</td>
  </tr>
)}
 
</table>

         </div> 
 

                </div>


</div>
               )}
               {active === "RSA FUND III" && (
             
              <div>  
            <div className="faq-type-content">
                     <h2 className="history-h2">RSA Fund III Price History</h2>
              <p id="crd-p" className="grey-p">
                {" "}
                Price Trend For RSA Fund III
              </p>
                <hr className="btm-bdr-rma" />

                </div>

                 <div className="faq-type-content white-cont">
                    <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
  <li className="nav-item funds-btn-gap" role="presentation">
    <button className="nav-link funds-btn active dark-p-history getTrendData7b" id="7" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true"> Last 7 Days </button>
  </li>
  <li className="nav-item funds-btn-gap" role="presentation">
    <button className="nav-link funds-btn dark-p-history getTrendData2b" id="2" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Last 14 Days </button>
  </li>
  <li className="nav-item funds-btn-gap" role="presentation">
    <button className="nav-link funds-btn dark-p-history getTrendData3b" id="3" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Last 1 Month</button>
  </li>
  <li className="nav-item" role="presentation">
    <button className="nav-link funds-btn dark-p-history getTrendData14b" id="14" data-bs-toggle="pill" data-bs-target="#pills-days" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Last 3 Months</button>
  </li>
 
</ul>
<div class="tab-content" id="pills-tabContent">
  <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
  <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
  <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
  <div class="tab-pane fade" id="pills-days" role="tabpanel" aria-labelledby="pills-disabled-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
</div>
            </div>


    <div className="faq-type-content">
                     <h4 className="history-h4">RSA Fund III Asset Allocation</h4>
              <p id="crd-p" className="grey-p">
                {" "}
                Asset Allocation for RSA Fund III
              </p>
                </div>

                                 <div className="mt-4 white-cont">
 <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
  <li className="nav-item funds-btn-gap" role="presentation">
    <ExcelExportButton data={fundThreeData} fileName="FUND I ASSEST ALLOCATION" />
     </li>
  <li className="nav-item funds-btn-gap" role="presentation">
        <CSVExportButton data={fundThreeData} fileName="FUND I ASSEST ALLOCATION" />
     </li>
  <li className="nav-item funds-btn-gap" role="presentation">
   <PDFExportButton data={fundThreeData} fileName="FUND I ASSEST ALLOCATION" />
     </li>
</ul>





           
 
         <div className="mt-3 table-overflow">

            <table>
  <tr>
    <th className="head-pad">Date</th>
    <th className="head-pad">Bond%</th>
    <th className="head-pad">Equity%</th>
    <th className="head-pad">Money Market%</th>
    <th className="head-pad">Others%</th>
  </tr>
 { fundThreeData.map((assetData, i) => 
             
  <tr>
    <td className="date-style"> {moment(assetData.date).format("MMM Do YYYY")} </td>
    <td className="percent-style"> {assetData.bond} </td>
    <td className="percent-style"> {assetData.equity}</td>
     <td className="percent-style">{assetData.moneyMarket}</td>
    <td className="percent-style">{assetData.cash}</td>
  </tr>
)}
 
</table>

         </div> 
 

                </div>


</div>
               )}
               {active === "RSA FUND IV" && (
                 
              <div>  
            <div className="faq-type-content">
                     <h2 className="history-h2">RSA Fund IV Price History</h2>
              <p id="crd-p" className="grey-p">
                {" "}
                Price Trend For RSA Fund IV
              </p>
                <hr className="btm-bdr-rma" />

                </div>

                 <div className="faq-type-content white-cont">
                    <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
  <li className="nav-item funds-btn-gap" role="presentation">
    <button className="nav-link funds-btn active dark-p-history getTrendData7c" id="7" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true"> Last 7 Days </button>
  </li>
  <li className="nav-item funds-btn-gap" role="presentation">
    <button className="nav-link funds-btn dark-p-history getTrendData3c" id="3" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Last 14 Days </button>
  </li>
  <li className="nav-item funds-btn-gap" role="presentation">
    <button className="nav-link funds-btn dark-p-history getTrendData2c" id="2" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Last 1 Month</button>
  </li>
  <li className="nav-item" role="presentation">
    <button className="nav-link funds-btn dark-p-history getTrendData14c" id="14" data-bs-toggle="pill" data-bs-target="#pills-days" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Last 3 Months</button>
  </li>
 
</ul>
<div class="tab-content" id="pills-tabContent">
  <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
  <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
  <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
  <div class="tab-pane fade" id="pills-days" role="tabpanel" aria-labelledby="pills-disabled-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
</div>
            </div>


    <div className="faq-type-content">
                     <h4 className="history-h4">RSA Fund IV Asset Allocation</h4>
              <p id="crd-p" className="grey-p">
                {" "}
                Asset Allocation for RSA Fund IV 
              </p>
                </div>

                                 <div className="mt-4 white-cont">
 <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
  <li className="nav-item funds-btn-gap" role="presentation">
    <ExcelExportButton data={fundFourData} fileName="FUND I ASSEST ALLOCATION" />
     </li>
  <li className="nav-item funds-btn-gap" role="presentation">
        <CSVExportButton data={fundFourData} fileName="FUND I ASSEST ALLOCATION" />
     </li>
  <li className="nav-item funds-btn-gap" role="presentation">
   <PDFExportButton data={fundFourData} fileName="FUND I ASSEST ALLOCATION" />
     </li>
</ul>





           
 
         <div className="mt-3 table-overflow">

            <table>
  <tr>
    <th className="head-pad">Date</th>
    <th className="head-pad">Bond%</th>
    <th className="head-pad">Equity%</th>
    <th className="head-pad">Money Market%</th>
    <th className="head-pad">Others%</th>
  </tr>
  { fundFourData.map((assetData, i) => 
             
  <tr>
    <td className="date-style"> {moment(assetData.date).format("MMM Do YYYY")} </td>
    <td className="percent-style"> {assetData.bond} </td>
    <td className="percent-style"> {assetData.equity}</td>
     <td className="percent-style">{assetData.moneyMarket}</td>
    <td className="percent-style">{assetData.cash}</td>
  </tr>
)}
 
</table>

         </div> 
 

                </div>


</div>
               )}
               {active === "RSA FUND V" && (
                 
              <div>  
            <div className="faq-type-content">
                     <h2 className="history-h2">RSA Fund V Price History</h2>
              <p id="crd-p" className="grey-p">
                {" "}
                Price Trend For RSA Fund V
              </p>
                <hr className="btm-bdr-rma" />

                </div>

                 <div className="faq-type-content white-cont">
                    <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
  <li className="nav-item funds-btn-gap" role="presentation">
    <button className="nav-link funds-btn active dark-p-history getTrendData7d" id="7" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true"> Last 7 Days </button>
  </li>
  <li className="nav-item funds-btn-gap" role="presentation">
    <button className="nav-link funds-btn dark-p-history getTrendData3d" id="3" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Last 14 Days </button>
  </li>
  <li className="nav-item funds-btn-gap" role="presentation">
    <button className="nav-link funds-btn dark-p-history getTrendData2d" id="2"data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Last 1 Month</button>
  </li>
  <li className="nav-item" role="presentation">
    <button className="nav-link funds-btn dark-p-history getTrendData14d" id="14" data-bs-toggle="pill" data-bs-target="#pills-days" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Last 3 Months</button>
  </li>
 
</ul>
<div class="tab-content" id="pills-tabContent">
  <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
  <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
  <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
  <div class="tab-pane fade" id="pills-days" role="tabpanel" aria-labelledby="pills-disabled-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
</div>
            </div>


    <div className="faq-type-content">
                     <h4 className="history-h4">RSA Fund V Asset Allocation</h4>
              <p id="crd-p" className="grey-p">
                {" "}
                Asset Allocation for RSA Fund V
              </p>
                </div>

                                 <div className="mt-4 white-cont">
 <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
  <li className="nav-item funds-btn-gap" role="presentation">
    <ExcelExportButton data={fundFiveData} fileName="FUND I ASSEST ALLOCATION" />
     </li>
  <li className="nav-item funds-btn-gap" role="presentation">
        <CSVExportButton data={fundFiveData} fileName="FUND I ASSEST ALLOCATION" />
     </li>
  <li className="nav-item funds-btn-gap" role="presentation">
   <PDFExportButton data={fundFiveData} fileName="FUND I ASSEST ALLOCATION" />
     </li>
</ul>





           
 
         <div className="mt-3 table-overflow">

            <table>
  <tr>
    <th className="head-pad">Date</th>
    <th className="head-pad">Bond%</th>
    <th className="head-pad">Equity%</th>
    <th className="head-pad">Money Market%</th>
    <th className="head-pad">Others%</th>
  </tr>
 { fundFiveData.map((assetData, i) => 
             
  <tr>
    <td className="date-style"> {moment(assetData.date).format("MMM Do YYYY")} </td>
    <td className="percent-style"> {assetData.bond} </td>
    <td className="percent-style"> {assetData.equity}</td>
     <td className="percent-style">{assetData.moneyMarket}</td>
    <td className="percent-style">{assetData.cash}</td>
  </tr>
)}
 
</table>

         </div> 
 

                </div>


</div>
               )}
               {active === "RSA FUND VI (Active)" && (
                 
              <div>  
            <div className="faq-type-content">
                     <h2 className="history-h2">RSA Fund VI (ACTIVE) Price History</h2>
              <p id="crd-p" className="grey-p">
                {" "}
                Price Trend For RSA Fund VI (ACTIVE)
              </p>
                <hr className="btm-bdr-rma" />

                </div>

                 <div className="faq-type-content white-cont">
                    <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
  <li className="nav-item funds-btn-gap" role="presentation">
    <button className="nav-link funds-btn active dark-p-history getTrendData7e" id="7" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true"> Last 7 Days </button>
  </li>
  <li className="nav-item funds-btn-gap" role="presentation">
    <button className="nav-link funds-btn dark-p-history getTrendData3e" id="3"data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Last 14 Days </button>
  </li>
  <li className="nav-item funds-btn-gap" role="presentation">
    <button className="nav-link funds-btn dark-p-history getTrendData2e" id="2" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Last 1 Month</button>
  </li>
  <li className="nav-item" role="presentation">
    <button className="nav-link funds-btn dark-p-history getTrendData14e" id="14" data-bs-toggle="pill" data-bs-target="#pills-days" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Last 3 Months</button>
  </li>
 
</ul>
<div class="tab-content" id="pills-tabContent">
  <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
  <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
  <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
  <div class="tab-pane fade" id="pills-days" role="tabpanel" aria-labelledby="pills-disabled-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
</div>
            </div>


    <div className="faq-type-content">
                     <h4 className="history-h4">RSA Fund VI (ACTIVE) Asset Allocation</h4>
              <p id="crd-p" className="grey-p">
                {" "}
                Asset Allocation for RSA Fund VI (ACTIVE)
              </p>
                </div>

                                 <div className="mt-4 white-cont">
 <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
  <li className="nav-item funds-btn-gap" role="presentation">
    <ExcelExportButton data={fundSixData} fileName="FUND I ASSEST ALLOCATION" />
     </li>
  <li className="nav-item funds-btn-gap" role="presentation">
        <CSVExportButton data={fundSixData} fileName="FUND I ASSEST ALLOCATION" />
     </li>
  <li className="nav-item funds-btn-gap" role="presentation">
   <PDFExportButton data={fundSixData} fileName="FUND I ASSEST ALLOCATION" />
     </li>
</ul>





           
 
         <div className="mt-3 table-overflow">

            <table>
  <tr>
    <th className="head-pad">Date</th>
    <th className="head-pad">Bond%</th>
    <th className="head-pad">Equity%</th>
    <th className="head-pad">Money Market%</th>
    <th className="head-pad">Others%</th>
  </tr>
 { fundSixData.map((assetData, i) => 
             
  <tr>
    <td className="date-style"> {moment(assetData.date).format("MMM Do YYYY")} </td>
    <td className="percent-style"> {assetData.bond} </td>
    <td className="percent-style"> {assetData.equity}</td>
     <td className="percent-style">{assetData.moneyMarket}</td>
    <td className="percent-style">{assetData.cash}</td>
  </tr>
)}
 
</table>

         </div> 
 

                </div>


</div>
               )}
               {active === "RSA FUND VI (Retiree)" && (
                
              <div>  
            <div className="faq-type-content">
                     <h2 className="history-h2">RSA Fund VI (RETIREE) Price History</h2>
              <p id="crd-p" className="grey-p">
                {" "}
                Price Trend For RSA Fund VI (RETIREE)
              </p>
                <hr className="btm-bdr-rma" />

                </div>

                 <div className="faq-type-content white-cont">
                    <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
  <li className="nav-item funds-btn-gap" role="presentation">
    <button className="nav-link funds-btn active dark-p-history getTrendData7f" id="7" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true"> Last 7 Days </button>
  </li>
  <li className="nav-item funds-btn-gap" role="presentation">
    <button className="nav-link funds-btn dark-p-history getTrendData3f" id="3" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Last 14 Days </button>
  </li>
  <li className="nav-item funds-btn-gap" role="presentation">
    <button className="nav-link funds-btn dark-p-history getTrendData2f" id="2" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Last 1 Month</button>
  </li>
  <li className="nav-item" role="presentation">
    <button className="nav-link funds-btn dark-p-history getTrendData14f" id="14" data-bs-toggle="pill" data-bs-target="#pills-days" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Last 3 Months</button>
  </li>
 
</ul>
<div class="tab-content" id="pills-tabContent">
  <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
  <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
  <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
  <div class="tab-pane fade" id="pills-days" role="tabpanel" aria-labelledby="pills-disabled-tab" tabindex="0">
    <Line options={options} data={data} className="full-width graph-height" />
  </div>
</div>
            </div>


    <div className="faq-type-content">
                     <h4 className="history-h4">RSA Fund VI Asset Allocation</h4>
              <p id="crd-p" className="grey-p">
                {" "}
                Asset Allocation for RSA Fund VI (RETIREE)
              </p>
                </div>

                                 <div className="mt-4 white-cont">
 <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
  <li className="nav-item funds-btn-gap" role="presentation">
    <ExcelExportButton data={fundSixRFData} fileName="FUND I ASSEST ALLOCATION" />
     </li>
  <li className="nav-item funds-btn-gap" role="presentation">
        <CSVExportButton data={fundSixRFData} fileName="FUND I ASSEST ALLOCATION" />
     </li>
  <li className="nav-item funds-btn-gap" role="presentation">
   <PDFExportButton data={fundSixRFData} fileName="FUND I ASSEST ALLOCATION" />
     </li>
</ul>





           
 
         <div className="mt-3 table-overflow">

            <table>
  <tr>
    <th className="head-pad">Date</th>
    <th className="head-pad">Bond%</th>
    <th className="head-pad">Equity%</th>
    <th className="head-pad">Money Market%</th>
    <th className="head-pad">Others%</th>
  </tr>
 { fundSixRFData.map((assetData, i) => 
             
  <tr>
    <td className="date-style"> {moment(assetData.date).format("MMM Do YYYY")} </td>
    <td className="percent-style"> {assetData.bond} </td>
    <td className="percent-style"> {assetData.equity}</td>
     <td className="percent-style">{assetData.moneyMarket}</td>
    <td className="percent-style">{assetData.cash}</td>
  </tr>
)}
 
</table>

         </div> 
 

                </div>


</div>
               )}
               {active === "Legacy Funds" && (
                 <div className="crd-div d-flex flex-wrap row-gap-5"></div>
               )}
               {active === "Additional Voluntary Contribution (AVC)" && (
                 <div className="crd-div d-flex flex-wrap row-gap-5"></div>
               )}
               {active === "Death Benefit" && (
                 <div className="crd-div d-flex flex-wrap row-gap-5"></div>
               )}
         </div>
      </div>
    </>
  );
};

export default History;
